import { getAuthDataCall, postAuthDataCall, getAuthDataCall2 } from '../utils';

export const getNotificationsList = async () => {
    const resp = await getAuthDataCall(`/auth/notifications`);
    return resp;
};

export const setUnreadNotificationToRead = async () => {
    const resp = await postAuthDataCall(`/auth/notifications/mark_all_unread_to_read`);
    return resp;
};

export const getNotificationApi = async (id) => {
    const resp = await getAuthDataCall(`/auth/notifications/${id}`);
    return resp;
};

export const getNotifications = async () => {
    const resp = await getAuthDataCall2('/auth/notifications/recent_unread');
    return resp;
};

export const getNotificationCount = async () => {
    const resp = await getAuthDataCall2('/auth/notifications/unread_count');
    return resp;
};
